<template>
  <span class="mark-text-container">
    <span v-for="(part, idx) in parts" :key="idx" class="mark-text-container__spans">
      <span v-if="idx > 0" class="mark-text">{{ substring }}</span>
      <span>{{ part }}</span>
    </span>
  </span>
</template>
<script>
  export default {
    name: 'MarkText',
    props: {
      text: {
        type: String,
        required: true,
      },
      substring: {
        type: String,
        default: '',
      },
    },
    computed: {
      parts() {
        return this.substring ? this.text.split(this.substring) : [this.text];
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mark-text-container {
    display: inline-flex;
    white-space: pre;
  }

  .mark-text-container__spans {
    display: contents;
  }

  .mark-text {
    background: #aed7fd;
  }
</style>
